export default __webpack_public_path__ + "73cd0548fe97c007102ef78f971e626f.png";